import { useEffect, useState } from "react";

export const useCursorsIntersection = ({ id }: { id: string }) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  useEffect(() => {
    const container = document.getElementById(
      "content-sgKecQsAYKy7MX4",
    ) as HTMLElement;
    const element = container?.querySelector(`#slide-id-${id}`);
    if (!element) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsIntersecting(entry.isIntersecting);
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(element);
  }, [id]);

  return isIntersecting;
};
